import { Injectable } from '@angular/core';
import { ImagesApiService } from '../infra/service';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({ providedIn: 'root', useClass: ImagesApiService })
export abstract class ImagesService {
  abstract photo(id?: string): Observable<string | undefined>;
}
